import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=760c6eed&scoped=true&"
import script from "./teaching.vue?vue&type=script&lang=js&"
export * from "./teaching.vue?vue&type=script&lang=js&"
import style0 from "./teaching.vue?vue&type=style&index=0&id=760c6eed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c6eed",
  null
  
)

export default component.exports